import React from 'react';
import { useContent } from '../lib/ContentContext';
import { PageHero } from '../components/site/PageHero';

/**
 * Generic legal/content page (Privacy Policy, Terms of Use).
 * contentKey: privacy_page | terms_page
 */
export default function LegalPage({ contentKey }) {
  const { content } = useContent();
  const page = content?.[contentKey];
  if (!page) return null;

  return (
    <div>
      <PageHero title={page.hero_title} subtitle={page.hero_subtitle} />
      <section className="py-12 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="post-body" data-testid={`${contentKey}-body`} dangerouslySetInnerHTML={{ __html: page.body }} />
        </div>
      </section>
    </div>
  );
}
